import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

export const Container = styled.div`
  position: relative;
  width: 100%;
  overflow: overlay;

  @media ${device.mobile} {
    height: 100%;
  }

  @media ${device.desktop} {
    height: 100%;
  }
`;

export const Wraper = styled.div`
  width: 100%;
  padding: 30px 10px 20px 10px;

  @media ${device.desktop} {
    margin-bottom: 20px;
    padding: 20px;
    background: rgba(45, 55, 72, 0.05);
    border-radius: 5px 5px 0px 0px;
  }
`;

export const Title = styled.h1`
  text-align: inherit;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2;
  color: var(--title-text-color);

  @media ${device.desktop} {
    margin-bottom: 10px;
    font-size: 25px;
  }
`;

export const Text = styled.p`
  text-align: inherit;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.27;
  color: var(--text-color);

  @media ${device.desktop} {
    font-size: 12px;
    line-height: 1.5;
  }
`;

export const ContentBox = styled.ul`
  width: 100%;

  @media ${device.desktop} {
    list-style: none;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    justify-content: center;
    grid-gap: 20px 40px;
    margin: 0 auto;
    max-width: 100%;
  }
`;
